import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useCompanyPoint = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [cashList, setCashList] = useState<CompanyCashListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0, company: '', cash: 0, company_srl: 0 });

  const {id} = useParams();
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.company.point.list, location.search],
    () =>
      fetcher.company.postCompanyPointList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',        
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',           
        gubun: searchParams.gubun ? String(searchParams.gubun) : '',
        company: id,
        order: searchParams.order ? String(searchParams.order) : '',
        reverse: searchParams.reverse ? String(searchParams.reverse) : '',        
      }),
    {
      onSuccess: (res: CompanyCashListResDto) => {
        switch (res.code) {
          case 200:
            setCashList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
              company: res.result?.company || '',
              cash: res.result?.point || 0,
              company_srl: res.result?.company_srl || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: companyCashInsert } = useMutation(
    [endpoints.company.point.add],
    fetcher.company.postCompanyPointAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: companyCashMemoUpdate } = useMutation(
    [endpoints.company.point.update],
    fetcher.company.postCompanyPointUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  return { isLoading, cashList, searchResult, refetch, companyCashInsert, companyCashMemoUpdate };
};

export default useCompanyPoint;
